import { render, staticRenderFns } from "./AppInfoBadgeComponent.vue?vue&type=template&id=24ca8e17&scoped=true&"
import script from "./AppInfoBadgeComponent.ts?vue&type=script&lang=ts&"
export * from "./AppInfoBadgeComponent.ts?vue&type=script&lang=ts&"
import style0 from "./AppInfoBadgeComponent.scss?vue&type=style&index=0&id=24ca8e17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca8e17",
  null
  
)

export default component.exports